/**
 * Create the pageview  tracking object
 */
import {
    getLoginData,
} from '@vfde-sails/tracking';
import { TRACKING_LOGGED_IN, TRACKING_NOT_LOGGED_IN, TRACKING_PAGE_TYPE, TRACKING_PLATFORM_TYPE, TRACKING_SITE_AREA } from '../constant';

/**
 * Create the page view tracking object
 * @param {object} trackingData - Tracking Data
 */
export const createTrackingPageView = (trackingData) => {
    // @TODO: tracking.siteStructure wieder über Sails Core, wenn dieser erweitert
    // const siteStructure = getSiteStructure(trackingData.pageName, BTX_BNT
    const siteStructure = ['privatkunden', 'kombi-angebote'];

    const loginStatus = getLoginData() ? TRACKING_LOGGED_IN : TRACKING_NOT_LOGGED_IN;

    const trackingPayload = {
        siteStructure,
        pageType: TRACKING_PAGE_TYPE,
        siteArea: TRACKING_SITE_AREA,
        loginStatus,
        platformType: TRACKING_PLATFORM_TYPE,
        error: {},
    };

    return trackingPayload;
};
